$ = require 'jquery'
Action = require 'models/action'
Board = require 'models/board'
Card = require 'models/card'
Enterprise = require 'models/enterprise'
IdCache = require 'db/id-cache'
PendingOrganization = require 'models/pending-organization'
List = require 'models/list'
Member = require 'models/member'
ModelCache = require 'db/model-cache'
Notification = require 'models/notification'
NotificationGroup = require 'models/notification-group'
Organization = require 'models/organization'
Plugin = require 'models/plugin'
Payloads = require 'network/payloads'
Promise = require 'bluebird'
Reaction = require 'models/reaction'
rpc = require 'network/rpc'
Time = require 'lib/time'
trackQuickloadEvent = require 'debug/trackQuickloadEvent'
Util = require 'lib/util'
_ = require 'underscore'
moment = require 'moment'
xtend = require 'xtend'
f = require 'effing'
ninvoke = require 'lib/util/ninvoke'
assert = require 'lib/assert'
ApiError = require 'network/api-error'

extendQuery = ({ query, mappingRules }, moreQuery) ->
  query: xtend(query, moreQuery)
  mappingRules: mappingRules

preloadUncalledSentinel = {}
REPLAY_CONCURRENCY = 5

quickload = (url) ->
  preload = preloadUncalledSentinel
  Promise.fromNode (next) ->
    preload = QuickLoad.load url, next
  .catch ([statusCode, responseText]) ->
    Promise.reject ApiError.fromResponse(statusCode, responseText)
  .tap -> assert preload != preloadUncalledSentinel, "Promises resolved synchronously; didn't get preload information from QuickLoad"
  .spread (data, xhr) ->
    [data, xhr, preload]

logPreload = (preload) ->
  if !preload?
    return
  timeSaved = Date.now() - preload.start
  trackQuickloadEvent 'quickload use', preload.url,
    int_key_1: 'time saved'
    int_val_1: timeSaved
  return

updateServerTime = (xhr) ->
  if (serverTime = xhr.getResponseHeader('X-Server-Time'))?
    Time.updateServerTime parseInt(serverTime, 10)
  return

# Since we do the board data loads all the time, use this to prevent some of
# the loads from happening if the board looks like it is already up to date
whenBoardNotUpToDate = (fx) ->
  (id) ->
    Promise.try ->
      ModelLoader.getUpToDateBoard(id) ? fx.call(ModelLoader, id)

_waitComplete = {}
_waitCallbacks = {}

module.exports = window.ModelLoader = ModelLoader =
  _history: []
  _replaying: false
  _loadApiData: (modelType, id, payload, [path, metadataHeaderName, isHeaderLoad]...) ->
    query = payload.query
    mappingRules = payload.mappingRules ? {}
    # If we gave a class like Board, convert that to "Board"
    if !_.isString(modelType)
      modelType = modelType::typeName
    path ?= "#{ Util.pluralize(modelType) }/#{id}"

    invitationTokens = Util.invitationTokens().join(',')
    if !_.isEmpty(invitationTokens)
      # Note that this has to match the behavior of quickload; where
      # invitationTokens is added as the last thing
      query = _.extend({}, query, { invitationTokens })

    url = QuickLoad.makeUrl("/1/#{ path }", query)

    quickload(url)
    .spread (data, xhr, preload) ->
      updateServerTime(xhr)
      logPreload(preload)
      [data, xhr]
    .tap ->
      if isHeaderLoad
        return
      else
        new Promise (resolve) -> ModelLoader.waitFor 'headerData', resolve
    .spread (data, xhr) ->
      ninvoke ModelCache, 'enqueueDelta', modelType, data, mappingRules
      .then (models) ->
        return models unless metadataHeaderName
        metadata = window.JSON.parse(xhr.getResponseHeader(metadataHeaderName))
        [models, metadata]

  getUpToDateBoard: (idBoardOrShortLink) ->
    if @isReplaying()
      return null

    idBoard = IdCache.getBoardId(idBoardOrShortLink)
    if !idBoard?
      return null

    board = ModelCache.get('Board', idBoard)
    if !board?
      return null

    lastUpdateChannel = rpc.getIxLastUpdate(board.id)
    if lastUpdateChannel?
      board
    else
      null

  isReplaying: ->
    @_replaying

  replay: ->
    @_replaying = true
    marker = ModelCache.mark()

    Promise.map(@_history, ({ owner, loadName, args }) =>
      @[loadName](args...)
    , { concurrency: REPLAY_CONCURRENCY })
    .then ->
      ModelCache.sweep(marker)
    .finally =>
      @_replaying = false
    .return()

  record: (owner, loadName, args...) ->
    if owner?
      @_history.push({ owner, loadName, args })
    else
      throw Error("Unclaimed #{ loadName }")

  for: (owner, loadName, args...) ->
    @record(owner, loadName, args...)
    @[loadName](args...)

  release: (owner) ->
    @_history = _.reject @_history, (entry) ->
      entry.owner == owner
    return

  loadHeaderData: ->
    @_loadApiData Member, 'me', Payloads.memberHeader, undefined, undefined, true
    .then (delta) -> ['Member', delta, Payloads.memberHeader.mappingRules]

  loadBoardsMenuData: ->
    @_loadApiData Member, 'me', Payloads.boardsMenuMinimal
    .then (delta) -> ['Member', delta, Payloads.boardsMenuMinimal.mappingRules]

  loadBoardMinimal: (id) ->
    @_loadApiData Board, id, Payloads.boardMinimal

  loadBoardData: (id, payload) -> @_loadApiData Board, id, payload

  loadBoardMembers: (id) ->
    @_loadApiData Member, id, {}, "boards/#{ id }/members"

  loadBoardAttachment: (idBoard) ->
    @_loadApiData Board, idBoard, Payloads.boardAttachment

  loadCanonicalCardData: (idCard) ->
    @_loadApiData Card, idCard, Payloads.canonicalCard, "cards/#{ idCard }"

  loadCardData: ([idBoard]..., idOrShortId) ->
    if idBoard?
      @_loadApiData Card, idOrShortId, Payloads.card, "boards/#{ idBoard }/cards/#{idOrShortId}"
    else
      @_loadApiData Card, idOrShortId, Payloads.card
  loadCardName: (idOrShortId) ->
    query =
      fields: ['name', 'shortLink'].join(',')
    @_loadApiData Card, idOrShortId, { query: query }
    .call 'get', 'name'
  loadCardCompleterData: (id) ->
    @_loadApiData Card, id, Payloads.cardCompleter
  loadCardId: (idBoard, idShort) ->
    @_loadApiData Card, idShort, Payloads.idCard, "boards/#{ idBoard }/cards/#{idShort}"
    .get 'id'
  loadCardDetails: (idCard, limit) ->
    @_loadApiData Card,
      idCard,
      extendQuery Payloads.cardDetails, { actions_limit: limit }
      "cards/#{idCard}"
  loadCardHideDetails: (idCard, limit) ->
    @_loadApiData Card,
      idCard,
      extendQuery Payloads.cardDetails,
        actions: 'commentCard,copyCommentCard,createCard,copyCard'
        actions_limit: limit
      "cards/#{idCard}"
  loadCardVoters: (id) ->
    @_loadApiData Card, id, Payloads.cardVoters, "cards/#{ id }"
  loadCardCopyData: (idBoard, idOrShortId) ->
    @_loadApiData Card, idOrShortId, Payloads.cardCopy, "boards/#{ idBoard }/cards/#{idOrShortId}"
  loadCardList: (idCard) ->
    @_loadApiData List, idCard, Payloads.cardList, "cards/#{ idCard }/list"
  loadCardAttachment: (idCard) ->
    @_loadApiData Card, idCard, Payloads.cardAttachment

  loadNotification: (id) ->
    @_loadApiData Notification, id, query:
      fields: 'all'

  loadNotificationGroups: (idCards) ->
    @_loadApiData NotificationGroup, null, { query: { idCards } }, 'notificationGroups'

  loadNotificationData: (idOrUsername) ->
    @_loadApiData Member, idOrUsername, Payloads.memberNotifications

  loadMoreNotificationData: (idOrUsername, limit) ->
    notifications = ModelCache.all('Notification')
    query = {
      display: true
      filter: 'all'
      limit: limit
      page: Math.floor(notifications.length / limit)
    }
    path = "members/#{ idOrUsername }/notifications"

    @_loadApiData Notification, null, { query }, path

  loadMoreUnreadNotifications: (idOrUsername, limit) ->
    unreads = ModelCache.all('Notification').filter (notification) ->
      notification.get('unread')
    query = {
      display: true,
      limit,
      read_filter: 'unread',
      page: Math.floor(unreads.length / limit)
    }
    path = "members/#{ idOrUsername }/notifications"

    @_loadApiData Notification, null, { query }, path

  loadAllNotificationGroupsBefore: (idNotification, limit, skip = 0) ->
    @loadMoreNotificationGroupData('me', limit, skip).then (models) =>
      idModels = _.chain(models)
      .map (model) ->
        model.get('notifications')
      .map (notifications) ->
        notifications.map (notification) -> notification.id
      .flatten()
      .value()

      if idModels.length > 0 && !_.contains(idModels, idNotification)
        return @loadAllNotificationGroupsBefore(idNotification, limit, skip + limit)

  loadMoreNotificationGroupData: (
    idOrUsername,
    limit,
    skip = ModelCache.all('NotificationGroup').length
  ) ->
    query = {
      limit,
      skip,
    }
    path = "members/#{ idOrUsername }/notificationGroups"

    @_loadApiData NotificationGroup, null, { query }, path

  loadMemberNotificationsCount: (idOrUsername) ->
    query = { filter: 'all', grouped: true }
    path = "members/#{ idOrUsername }/notificationsCount"

    @_loadApiData 'notificationsCount', null, { query }, path

  loadMemberBoardsData: (idOrUsername) ->
    @_loadApiData Member, idOrUsername, Payloads.memberBoards

  loadMemberCardsData: (idOrUsername) ->
    @_loadApiData Member, idOrUsername, Payloads.memberCards

  loadMemberCards: (idOrUsername, modifiedSince) ->
    query =
      filter: 'visible'
      stickers: true
      attachments: true
      members: true

    if modifiedSince
      query.modifiedSince = modifiedSince

    @_loadApiData Card, null, { query }, "members/#{ idOrUsername }/cards"

  loadMemberEmail: (idOrUsername) ->
    @_loadApiData Member, idOrUsername, query:
      fields: 'email'
      invitationTokens: Util.invitationTokens().join(',')

  loadOrganizationMemberGhost: (idOrg, username) ->
    # If we have an invite to this organization (i.e. an invitation token
    # in our cookies) then we need to load the ghost data so we can
    # display the invitation banner
    idGhost = Util.inviteTokenFor(idOrg)?.split('-')[0]
    if !idGhost?
      return Promise.resolve({})

    query =
      fields: Payloads.memberFields
      invitationTokens: Util.invitationTokens().join(',')

    # Maybe the invitation has already been used or something; we
    # never want to prevent loading of the organization page
    @_loadApiData Member, idGhost, { query }
    .catch ApiError, -> {}

  loadMyBoardsUnreadData: ->
    @_loadApiData Member, 'me', Payloads.memberUnreadBoards

  loadMoreActionData: (modelType, idOrName, page, limit, [idModels, filter]...) ->
    query = { filter: 'all', limit, page, display: true }
    if idModels?
      query.idModels = idModels.join(',')
    if filter?
      query.filter = filter

    @_loadApiData Action, idOrName, { query }, "#{modelType}s/#{ idOrName }/actions"

  loadClosedCards: (idBoard, { limit, before }) ->
    query = { stickers: true, attachments: true, pluginData: true, customFieldItems: true }
    if limit? then query.limit = limit
    if before? then query.before = before

    @_loadApiData Card, idBoard, { query }, "boards/#{ idBoard }/cards/closed"

  loadClosedBoards: ->
    @_loadApiData Board, null, { query: { filter: 'closed' } }, 'members/me/boards'

  loadArchivedLists: (idBoard) ->
    @_loadApiData Board, idBoard, Payloads.archivedLists

  loadMemberPaidAccount: (idOrUsername) ->
    @_loadApiData Member, idOrUsername, Payloads.memberPaidAccount

  loadMemberAccountData: (idOrUsername) ->
    @_loadApiData Member, idOrUsername, Payloads.memberAccount

  loadMemberLogins: (idOrUsername) ->
    @_loadApiData Member, idOrUsername, query:
      fields: 'email'
      logins: true

  loadMemberProfileData: (idOrUsername) ->
    payload = Payloads.memberProfile
    daysBack = Payloads.memberProfile_daysBack
    payload.action_since = moment().subtract(daysBack, 'days').toString()
    @_loadApiData Member, idOrUsername, Payloads.memberProfile

  loadMemberCustomBackgrounds: (idOrUsername) ->
    @_loadApiData Member, idOrUsername, query:
      fields: ''
      boardBackgrounds: 'custom'

  loadMemberCustomStickers: (idOrUsername) ->
    @_loadApiData Member, idOrUsername, query:
      fields: ''
      customStickers: 'all'

  loadMemberCustomEmoji: (idOrUsername) ->
    @_loadApiData Member, idOrUsername, query:
      fields: ''
      customEmoji: 'all'

  loadMemberEnterpriseUserType: (enterpriseIdOrName, idOrUsername) ->
    query = { fields: 'userType' }
    @_loadApiData Member, idOrUsername, { query }, "enterprises/#{enterpriseIdOrName}/members/#{idOrUsername}"

  loadMemberEnterpriseActive: (enterpriseIdOrName, idOrUsername) ->
    query = { fields: 'active' }
    @_loadApiData Member, idOrUsername, { query }, "enterprises/#{enterpriseIdOrName}/members/#{idOrUsername}"


  _loadOrganizationPayload: (payload, idOrOrgName) ->
    @_loadApiData Organization, idOrOrgName, payload

  loadOrganizationData: (idOrOrgName) ->
    @_loadOrganizationPayload(Payloads.organization, idOrOrgName)

  loadOrganizationBoardsData: (idOrOrgName) ->
    @_loadOrganizationPayload(Payloads.organizationBoardsPage, idOrOrgName)

  loadOrganizationPaidAccount: (idOrOrgName) ->
    @_loadOrganizationPayload(Payloads.organizationPaidAccount, idOrOrgName)

  loadOrganizationMinimal: (idOrOrgName) ->
    @_loadOrganizationPayload(Payloads.organizationMinimal, idOrOrgName)

  loadOrganizationMembersData: (idOrOrgName) ->
    @_loadOrganizationPayload(Payloads.organizationMembers, idOrOrgName)

  loadOrganizationMembersExtraData: (idOrOrgName) ->
    @_loadOrganizationPayload(Payloads.organizationMembersExtra, idOrOrgName)

  loadOrganizationMembersMinimal: (idOrOrgName) ->
    @_loadOrganizationPayload(Payloads.organizationMembersMinimal, idOrOrgName)

  loadOrganizationExportData: (idOrOrgName) ->
    @_loadOrganizationPayload(Payloads.organizationExports, idOrOrgName)

  loadOrganizationMemberMinimal: (idOrOrgName, idOrUsername) ->
    @_loadApiData Member, idOrUsername, Payloads.memberMinimal

  loadMemberOrganizationsDeactivatedMembers: ->
    @_loadApiData Organization, null, Payloads.memberOrganizationDeactivatedMembers, 'members/me/organizations'

  loadOrgMemberCardData: (idOrOrgName, idOrUsername) ->
    path = "organization/#{idOrOrgName}/members/#{idOrUsername}/cards"
    @_loadApiData Card, idOrOrgName, Payloads.orgMemberCards, path

  loadOrgNameById: (idOrganization) ->
    query =
      fields: 'name'
    @_loadApiData Organization, idOrganization, { query }
    .call 'get', 'name'

  loadCurrentBoardData: whenBoardNotUpToDate (id) ->
    @loadBoardData id, Payloads.currentBoardMinimal

  loadBoardSecondary: whenBoardNotUpToDate (id) ->
    @_loadApiData Board, id, Payloads.currentBoardSecondary

  loadBoardPluginData: whenBoardNotUpToDate (id) ->
    @_loadApiData Board, id, Payloads.currentBoardPluginData

  loadBoardCompleterData: (id) ->
    @_loadApiData Board, id, Payloads.boardCompleter

  loadBoardName: (idBoard) ->
    query =
      fields: ['name', 'closed', 'shortLink'].join(',')
    @_loadApiData Board, idBoard, { query }
    .call 'get', 'name'

  loadMembersOfEnterprise: (enterpriseIdOrName, params) ->
    query = _.extend(fields: Payloads.enterpriseMemberFields, params)
    @_loadApiData Member, enterpriseIdOrName, { query },
      "enterprises/#{ enterpriseIdOrName }/members",
      "X-Trello-API-Query-Meta"

  loadEnterpriseOrganizations: (enterpriseIdOrName, params) ->
    query = _.extend(fields: Payloads.enterpriseOrganizationFields, params)
    @_loadApiData Organization, enterpriseIdOrName, { query },
      "enterprises/#{ enterpriseIdOrName }/organizations",
      "X-Trello-API-Query-Meta"

  loadEnterprisePendingOrganizations: (enterpriseIdOrName, query) ->
    @_loadApiData PendingOrganization, enterpriseIdOrName, { query },
      "enterprises/#{ enterpriseIdOrName }/pendingOrganizations",
      "X-Trello-API-Query-Meta"

  loadEnterprisePublicBoards: (enterpriseIdOrName, params) ->
    query = _.extend(params,
      filter: 'public'
      organization: true
      members: 'admins'
    )

    @_loadApiData Board, enterpriseIdOrName, { query },
      "enterprises/#{ enterpriseIdOrName }/boards",
      "X-Trello-API-Query-Meta"

  loadEnterprise: (enterpriseIdOrName, query) ->
    query ?=
      organizations: 'all'
      fields: [
        'displayName'
        'idAdmins'
        'idOrganizations'
        'pendingOrganizations'
        'name'
        'organizationPrefs'
        'prefs'
        'products'
        'ssoActivationFailed'
        'ssoDateDelayed'
      ].join(',')
    @_loadApiData Enterprise, enterpriseIdOrName, { query }

  loadHighlights: ({ before, since, organization }) ->
    query = {
      board_customFields: true
      board_memberships: 'all'
      card_customFieldItems: true
      action_reactions: true
    }

    if before then query.before = before
    if since then query.since = since
    if organization then query.organization = organization

    @_loadApiData 'highlights', null, { query }, 'members/me/highlights'

  loadUpNext: ->
    query = {
      board_customFields: true
      board_memberships: 'all'
      card_customFieldItems: true
      action_reactions: true
    }

    @_loadApiData 'upNext', null, { query }, 'members/me/upNext'

  loadMyOrganizations: ->
    @loadMemberOrganizations 'me'

  loadMemberOrganizations: (idMember) ->
    @_loadApiData Member, idMember, Payloads.organizations

  loadSearchData: (query) ->
    @_loadApiData 'search', null, { query }, 'search'

  loadModel: (modelType, id, payload) ->
    @_loadApiData modelType, id, payload

  loadBoardPlugins: (id) ->
    @_loadApiData(
      Plugin
      null
      query:
        { filter: 'all' }
      "boards/#{ id }/plugins"
    )

  loadBoardEnabledPlugins: (id) ->
    @_loadApiData(
      Plugin
      null
      query:
        { filter: 'enabled' }
      "boards/#{ id }/plugins"
    )

  loadCustomFields: (id) ->
    @_loadApiData Board, id, Payloads.customFields

  loadQuickBoardsData: ->
    @_loadApiData Member, 'me', Payloads.memberQuickBoards

  loadQuickBoardsSearch: (search) ->
    @_loadApiData 'search', null, {
      query: Payloads.quickBoardsSearch.query(search)
    }, 'search'

  loadAction: (id) ->
    @_loadApiData Action, id, Payloads.action

  loadReactions: (idAction) ->
    @_loadApiData Reaction, idAction, {}, "actions/#{ idAction }/reactions"

  loadBCFeatures: (id) ->
    @_loadApiData Organization, id, Payloads.bcFeatures

  triggerWaits: (type) ->
    _waitComplete[type] = true

    for callback in _waitCallbacks[type] ? []
      callback()
    delete _waitCallbacks[type]

  waitFor: (type, callback) ->
    if _waitComplete[type]
      callback()
    else
      (_waitCallbacks[type] ?= []).push(callback)

  await: (type) ->
    new Promise (resolve) =>
      @waitFor type, resolve



// WEBPACK FOOTER //
// ./app/scripts/db/model-loader.coffee